export const messages = {
  title: 'Loyalty Event Offers',
  configurePageTitle: 'Configure Loyalty Event',
  updatePageTitle: 'Update Loyalty Event',
  subtitle: 'Provide member benefits based on their non-transactional behaviors',
  listPageTitle: 'Loyalty Event Offers',
};
